import type {
  AppWithExclusionState,
  CategoryInfo,
} from '@/features/electron-api';

import type { AppAccessMode } from '@electron/shared/types';

export const APP_ACCESS_MODES: AppAccessMode[] = ['block', 'allow'];

export const APP_ACCESS_MODE_LABELS: Record<AppAccessMode, string> = {
  block: 'All apps, with exceptions',
  allow: 'Only selected apps',
};

export const APP_ACCESS_MODE_DESCRIPTIONS: Record<AppAccessMode, string> = {
  block: 'Include apps automatically. Turn off any you want to exclude.',
  allow: 'Include only the apps you turn on. New apps stay excluded.',
};

const accessRowPresentation = (subject: string, isExcluded: boolean) => ({
  checked: !isExcluded,
  switchLabel: `Allow Littlebird to read ${subject}`,
  status: isExcluded ? 'Excluded' : 'Included',
});

export const appRowPresentation = (
  app: Pick<AppWithExclusionState, 'displayName' | 'isExcluded'>
) => accessRowPresentation(app.displayName, app.isExcluded);

export const categoryRowPresentation = (
  category: Pick<CategoryInfo, 'name'>,
  isExcluded: boolean
) => accessRowPresentation(`${category.name} websites`, isExcluded);
